import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FileText, Clock, Award, HelpCircle } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, EmptyState, Money, Badge } from "@/components/common";
import { Button } from "@/components/ui/button";

export default function LearnerTests() {
  const navigate = useNavigate();
  const [tests, setTests] = useState([]);
  useEffect(() => { api.get("/tests").then(({ data }) => setTests(data)); }, []);
  return (
    <div data-testid="learner-tests-page">
      <PageHeader title="Test Series" subtitle="Attempt tests and track your progress" />
      {tests.length === 0 ? <EmptyState icon={FileText} title="No tests available" /> : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {tests.map((t) => (
            <div key={t.id} className="bg-white border border-border rounded-xl p-6" data-testid={`ltest-${t.id}`}>
              <div className="flex items-start justify-between">
                <div className="h-11 w-11 rounded-lg viriks-navy text-amber flex items-center justify-center"><FileText size={20} /></div>
                {t.price === 0 ? <Badge tone="green">FREE</Badge> : <Money amount={t.price} className="font-bold" />}
              </div>
              <h3 className="font-heading font-semibold text-navy mt-4">{t.title}</h3>
              <div className="flex flex-wrap gap-3 mt-3 text-xs text-muted-foreground">
                <span className="flex items-center gap-1"><HelpCircle size={13} /> {t.question_count} Qs</span>
                <span className="flex items-center gap-1"><Clock size={13} /> {t.duration} min</span>
                <span className="flex items-center gap-1"><Award size={13} /> {t.total_marks} marks</span>
              </div>
              <Button className="w-full mt-5 viriks-amber text-white font-semibold" onClick={() => navigate(`/learner/test/${t.id}`)} data-testid={`attempt-${t.id}`}>Start Test</Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
